import FileSaver from 'file-saver';
import blob from 'blob';

function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}

export const fetchAssetsPerformance = (id, token) => {
  return dispatch => {
  dispatch({ type: 'FETCH_ASSETS_PERFORMANCE_REQUEST' });
    const headers = {"Content-Type": "application/json", "Authorization": "JWT " + token};
    return fetch(process.env.REACT_APP_HTTP_PROTOCOL + "://" + process.env.REACT_APP_API_IP + "/api/results/performanceassets/" + id + "/", {headers, })
      .then(handleErrors)
      .then(res => res.json())
      .then(assetsperformance => {
        return dispatch({
          type: 'FETCH_ASSETS_PERFORMANCE_SUCCESS',
          assetsperformance
        })
      })
      .catch((error) => (
        dispatch({ type: 'FETCH_ASSETS_PERFORMANCE_FAILURE', error_type: error, error: true })
      ))
  }
}

export const createXLSXAssetsPerformance = (text, token) => {
  return dispatch => {
    const headers = {"Content-Type": "application/json", "Authorization": "JWT " + token};
    let body = JSON.stringify(text);
    return fetch(process.env.REACT_APP_HTTP_PROTOCOL + "://" + process.env.REACT_APP_API_IP + "/api/results/performanceassets/", {headers, method: "POST", body})
      .then(handleErrors)
      .then(res => res.blob())
      .then(assetsperformance => {
        FileSaver.saveAs(assetsperformance, 'nameFile.xlsx');
    })
  }
}
